import testImage from 'local/lib/testImage';

export default function testIpType(m) {
	return Promise.all([
		testImage('https://ipv4.bredbandskollen.se/1x1pixel.jpg?bust=' + new Date().getTime()),
		testImage('https://ipv6.bredbandskollen.se/1x1pixel.jpg?bust=' + new Date().getTime()),
	]).then(([ipv4, ipv6]) => {
		m.setData({
			ipv4Supported: ipv4 || !ipv6,
			ipv6Supported: ipv6,
			iptype: (ipv6 && !ipv4) ? 'ipv6' : 'ipv4',
		});

		return [ipv4, ipv6, m.data.iptype];
	});
}
